<template>
  <div class="app">
    <div id="layers">
      <p>图例 :</p>
      <p @click="showHideLayer('水厂')"><img :src="factory" alt="" class="tuli" /> 水 厂</p>
      <p @click="showHideLayer('水源')"><img :src="watersource" alt="" class="tuli" /> 水 源</p>
      <p @click="showHideLayer('阀门')"><img :src="fm" alt="" class="tuli" /> 阀 门</p>
    </div>
    <div id="map" :style="mapstyle">
      <div style="height: 100%; width: 100%; z-index: 9999999" v-if="isLoading">
        <a-spin size="large" style="top: 50%; right: 60%; position: absolute" title="加载中" />
      </div>
    </div>
    <a-modal title="照片" :footer="null" :visible="visible" width="50%" @ok="handleOk" @cancel="handleCancel">
      <p><img :src="imgUrl" alt="" id="humbimg" /></p>
    </a-modal>
  </div>
</template>

<script>
import Map from 'ol/Map'
import ImageWMS from 'ol/source/ImageWMS'
import { Image as ImageLayer } from 'ol/layer'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import { getLegendDetailByCode, getGeophysicalPoint, getPipeFindPoint } from '@/api/manage'
// import Draw from 'ol/interaction/Draw'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style'
import Circle from 'ol/style/Circle'
import Icon from 'ol/style/Icon'
import Text from 'ol/style/Text'
import Scanler from 'ol/control/ScaleLine'
import GeoJSON from 'ol/format/GeoJSON'
import * as olProj from 'ol/proj'
import * as turf from '@turf/turf'
export default {
  props: {
    mapstyle: {
      type: Object,
      default: function () {
        return { width: '100%', height: '500px' }
      }
    }
  },
  data () {
    return {
      mapcenter: [],
      showshuiyuan: false,
      showfactory: false,
      showfm: false,
      visible: false,
      waterSource: [],
      factorySource: [],
      imgUrl: '',
      isLoading: false,
      factory: '/factory.png',
      watersource: '/watersource.png',
      fm: require('@/assets/myImg/1/阀门.png')
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    }
  },
  mounted () {
    this.initMap()
  },
  methods: {
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      // var projection = getProjection('EPSG:4326')
      this.mapcenter = this.currentUser.tenant.point
      const road_layer = new TileLayer({
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          // url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=1&style=8'
        })
      })
      this.map = new Map({
        view: new View({
          center: this.mapcenter, // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 13, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        target: 'map', // 地图容器id
        layers: [road_layer]
      })
      const scanler = new Scanler()
      this.map.addControl(scanler)
      // this.addGeojson(streetData)
      this.getWmsLayers()
      this.getsource()
      this.getgeoJson()
    },
    showHideLayer (layer) {
      switch (layer) {
        case '水厂':
          if (this.showfactory) {
            this.removeLayer(layer)
            this.showfactory = false
          } else {
            this.factorySource.map((item) => {
              this.addSimplePoint(item.title, item.name, item.id, item.style, item.pointX, item.pointY)
            })
            this.showfactory = true
          }
          break
        case '水源':
          if (this.showshuiyuan) {
            this.removeLayer(layer)
            this.showshuiyuan = false
            console.log(this.showshuiyuan)
          } else {
            this.waterSource.map((item) => {
              this.addSimplePoint(item.title, item.name, item.id, item.style, item.pointX, item.pointY)
            })
            this.showshuiyuan = true
            console.log(this.showshuiyuan)
          }
          break
        case '阀门':
          if (this.showfm) {
            this.removeLayer(layer)
            this.showfm = false
            console.log(this.showfm)
          } else {
            this.getfm(layer)
            console.log(this.showfm)
          }
          break
      }
    },
    getsource () {
      const url = '/pipe-network/tenant_water_works_configs/list'
      this.$http.get(url).then((resolve) => {
        console.log(JSON.stringify(resolve))
        if (resolve.data.length > 0) {
          const coordinates = []
          resolve.data.map((item) => {
            console.log(typeof item.geoJson)
            const coordinate = JSON.parse(item.geoJson).coordinates
            coordinates.push({ name: item.name, id: item.id, pointX: item.pointX, pointY: item.pointY })
          })
          var point1 = turf.point([coordinates[0].pointX, coordinates[0].pointY])
          var point2 = turf.point([coordinates[1].pointX, coordinates[1].pointY])
          var midpoint = turf.midpoint(point1, point2)
          midpoint = midpoint.geometry.coordinates
          this.map.getView().setCenter(midpoint)
          coordinates.map((item) => {
            console.log(JSON.stringify(item))
            if (item.name.includes('水厂')) {
              this.factorySource.push({
                title: '水厂',
                name: item.name,
                id: item.id,
                style: this.stylefunctionFactory,
                pointX: item.pointX,
                pointY: item.pointY
              })
              this.addSimplePoint('水厂', item.name, item.id, this.stylefunctionFactory, item.pointX, item.pointY)
            } else {
              this.waterSource.push({
                title: '水源',
                name: item.name,
                id: item.id,
                style: this.stylefunctionWaterSource,
                pointX: item.pointX,
                pointY: item.pointY
              })
              this.addSimplePoint('水源', item.name, item.id, this.stylefunctionWaterSource, item.pointX, item.pointY)
            }
          })
          this.showfactory = true
          this.showshuiyuan = true
          var that = this
          this.map.on('click', function (e) {
            console.log('click=====map')
            that.map.forEachFeatureAtPixel(e.pixel, (feature) => {
              if (feature.get('name') == '龙虎洞水源' || feature.get('name') == '桂枝岭水厂') {
                const id = feature.get('remark')
                const url = '/pipe-network/tenant_water_works_configs/' + id
                that.$http.get(url).then(({ data }) => {
                  that.imgUrl = data.fileUrl
                  that.showModal()
                })
              } else {
                console.log(feature.get('name'), '不调用！')
              }
            })
          })
        }
      })
    },
    getgeoJson () {
      const url = '/pipe-network/ext_layer/geom'
      this.$http.get(url).then(({ data }) => {
        // console.log(JSON.stringify(JSON.parse(data)))
        const geoJson = JSON.parse(data)
        this.addGeojson(geoJson, true, '水厂到水源')
      })
    },
    showModal () {
      this.visible = true
    },
    handleOk () {
      this.visible = false
    },
    handleCancel () {
      this.visible = false
    },
    addSimplePoint (title, name, id, stylefunction, x, y) {
      const point = new Point([x, y])
      const feature = new Feature({
        geometry: point,
        name: name,
        remark: id
      })
      const vectorSource = new VectorSource()
      vectorSource.addFeature(feature)
      const vectorLayer = new VectorLayer({
        title: title,
        source: vectorSource,
        zIndex: 9,
        style: stylefunction
      })
      this.map.addLayer(vectorLayer)
    },
    stylefunctionFactory (feature) {
      const name = feature.get('name')
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: this.factory,
          scale: 0.8
        }),
        text: new Text({
          text: name,
          font: '16px Calibri,sans-serif',
          textAlign: 'center',
          offsetX: 50,
          offsetY: 30,
          fill: new Fill({
            color: 'rgb(0 177 240)'
          })
        })
      })
    },
    stylefunctionWaterSource (feature) {
      const name = feature.get('name')
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: this.watersource,
          scale: 0.8
        }),
        text: new Text({
          text: name,
          font: '16px Calibri,sans-serif',
          textAlign: 'center',
          offsetX: 50,
          offsetY: 30,
          fill: new Fill({
            color: 'rgb(0 177 240)'
          })
        })
      })
    },
    // 添加geojson
    addGeojson (geojsonObject, style = null, name) {
      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(geojsonObject)
      })
      var vectorLayer = new VectorLayer({
        title: name,
        source: vectorSource
      })
      if (style) {
        vectorLayer.setStyle(
          new Style({
            fill: new Fill({
              // 填充样式
              color: '#00b1f0'
            }),
            stroke: new Stroke({
              // 线样式
              color: '#00b1f0',
              width: 3
            }),
            image: new Icon({
              src: require('@/assets/myImg/1/阀门.png'),
              scale: 0.3
            })
          })
        )
      }
      this.map.addLayer(vectorLayer)
    },
    getWmsLayers () {
      getLegendDetailByCode('new_pipe_network_legend').then(({ data }) => {
        data.layerList.map((item) => {
          // console.log(JSON.stringify(item));
          if (item.layerName == '水厂范围') {
            this.wmsLayers(item.workspace, '', item.dataSource, '水厂范围')
          }
          // if(item.layerName == "水源到水厂" ){ // || item.layerName == '阀门'
          //     // console.log(JSON.stringify(item));
          //   this.wmsLayers(item.workspace,item.showFilterCondition,item.dataSource);
          // }
          if (item.layerName == '阀门') {
            this.getfm('阀门')
          }
        })
      })
    },
    // 添加阀门
    getfm (name) {
      var cc = {
        type: 'FeatureCollection',
        features: []
      }
      getPipeFindPoint().then((res) => {
        console.log('asdasd', res)
        res.data.forEach((item) => {
          console.log('json', JSON.parse(item.geoJson))
          cc.features.push(JSON.parse(item.geoJson))
        })
        this.addGeojson(cc, true, name)
        this.showfm = true
      })
    },
    wmsLayers (workspace, cql = '', name, title) {
      console.log(name)
      const params = { LAYERS: name, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params: params,
        serverType: 'geoserver',
        url: `/api/geoserver/${workspace}/wms`
      })
      const wmsLayer = new ImageLayer({
        title: title,
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 9999
      })
      const that = this
      wmsSource.on('imageloadstart', function (event) {
        that.isLoading = true
      })
      wmsSource.on('imageloadend', function (event) {
        that.isLoading = false
      })
      this.map.addLayer(wmsLayer)
    },
    removeLayer (layer) {
      var allLayer = this.map.getLayers().array_
      var layers = []
      allLayer.forEach((item) => {
        if (item.values_.title == layer) {
          layers.push(item)
        }
      })
      layers.map((item) => {
        this.map.removeLayer(item)
      })
      // switch(layer){
      //   case "轨迹":
      //   this.isshowpath = false;
      //   this.showinfo = false;
      //   this.name = '';
      //   this.starttime = '';
      //   this.endtime = '';
      //   this.round = '';
      //   this.counttime = '';
      //   this.distance = 0;
      //   break;
      //   case "用户":
      //   this.isshowonline = false;
      //   break;
      //   case "事件":
      //   this.isshowevents = false;
      //   break;
      //   case "工单":
      //   this.isshoworders = false;
      //   break;
      // }
    }
  }
}
</script>

<style scoped>
.app {
  position: relative;
}

.tuli {
  width: 36px;
  height: 36px;
}

#map {
  z-index: -1;
}

#humbimg {
  width: 100%;
}

#layers {
  width: auto;
  height: auto;
  background: rgba(0, 60, 136, 0.5);
  position: absolute;
  bottom: 0.5em;
  right: 0.5em;
  z-index: 9;
  color: white;
  padding: 20px;
  font-size: 16px;
}
</style>
